import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/Assets-V4/Switching/usw-24-poe@2x.jpg";
import v3Image from "../../assets/Switching/standard24PoE.jpg";
import type { Product } from "../../types";
import { gigabitEthernet } from "../product-groups/switching/gbe-1u";
import { productListSwitchingValue } from "../product-list-groups/productListSwitchingValue";
import {
  downlinkSpeed,
  etherlighting,
  mounting,
  outdoorReady,
  poeAvailability,
  poeOutput,
  portCount,
  powerMethod,
  proAvSupport,
  switchTechnology,
  uplinkSpeed,
} from "../properties";

export const standard24PoE: Product = {
  id: "standard24PoE",
  productTitle: "Standard 24 PoE",
  description: "standard24PoE.description",
  techspecsPath: [SiteId.TechSpecs, "/unifi/switching/usw-24-poe"],
  storePathParts: { productSlug: "usw-24-poe", category: "switching-standard" },
  sku: "USW-24-POE",
  image: { src: image, width: 200, height: 140 },
  v3Image: {
    src: v3Image,
    width: 284,
    height: 120,
  },
  productListGroup: productListSwitchingValue,
  productGroup: gigabitEthernet,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '442 x 200 x 44 mm\n(17.4 x 7.9 x 1.7")',
      },
    },
    {
      propertyId: switchTechnology.id,
      value: {
        type: "translation",
        value: "commons.switchingTechnology.layer2",
      },
    },
    {
      propertyId: portCount.id,
      value: { type: "string", value: "24" },
    },
    {
      propertyId: downlinkSpeed.id,
      value: { type: "string", value: "1 Gbps" },
    },
    {
      propertyId: uplinkSpeed.id,
      value: { type: "string", value: "1 Gbps" },
    },
    {
      propertyId: poeOutput.id,
      value: {
        type: "translation",
        value: "commons.poeOutput.upToPoe+",
      },
    },
    {
      propertyId: poeAvailability.id,
      value: { type: "string", value: "95 W" },
    },
    {
      propertyId: etherlighting.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: proAvSupport.id,
      value: { type: "boolean", value: false },
    },

    {
      propertyId: "generalRedundancy",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: powerMethod.id,
      value: {
        type: "translation",
        value: "commons.powerMethod.acPower",
      },
    },
    {
      propertyId: mounting.id,
      value: {
        type: "translation",
        value: "commons.mounting.rack",
      },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "boolean", value: false },
    },
  ],
};
